export enum NavGroupId {
  PLAN_AND_DO = 'plan_and_do',
  MY_CIRCLE = 'my_circle',
  EXTRA = 'extra'
}
